// Screen 9, Settings (SPEC §8 Screen 9, §14.6, §15.3; J-068). SPEC §15.3 gives the Organization and
// Measures tabs to the roles holding `acoSettings.readCore` (admin, analyst) and saving to admin, so the
// analyst reads them read-only and any other role reads why the page is empty; the API refuses either way.
import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { metadataQueryOptions } from "@/features/aco-shell/api/metadata";
import { knownNotProduction } from "@/features/aco-shell/default-aco";
import { meAccessQueryOptions } from "@/features/auth/api/me-access";
import { usePermission } from "@/features/auth/use-permission";
import { SettingsScreen } from "@/features/aco-settings/components/settings-screen";

import { SettingsPreview } from "./-settings-preview";

export const Route = createFileRoute("/_authenticated/settings")({
  // J-209 (inbox file 20 item 4): the shell draws "Settings is for the admin and analyst roles" for any
  // other role, and "no ACO access" for an account without a TENANT assignment, whose reads all refuse.
  staticData: { screenName: "Settings", requires: { acoSettings: ["readCore"] } },
  component: SettingsPage,
});

function SettingsPage() {
  const canUpdate = usePermission({ acoSettings: ["update"] });
  const canReadAll = usePermission({ acoSettings: ["readAll"] });
  const metadata = useQuery(metadataQueryOptions());
  // J-208: the shell's selected year, defaulting to the newest configured one as the selector does.
  const year = Route.useSearch().year ?? metadata.data?.years[0];
  const access = useQuery(meAccessQueryOptions());
  return (
    <>
      {/* J-245: every user's own password page; the top bar's user menu links it on every screen. */}
      <p className="pt-2 text-sm">
        <Link to="/settings/password" className="underline">
          Change your password
        </Link>
      </p>
      <SettingsScreen
        canUpdate={canUpdate}
        canReadAll={canReadAll}
        renderPreview={(ui) => <SettingsPreview ui={ui} />}
        // J-209 (inbox 06 PR D item 16): production until metadata says otherwise, so the Synthetic
        // Data tab never shows in production while metadata loads.
        production={!knownNotProduction(metadata.data)}
        year={year}
        allAcos={access.data?.allAcos === true}
      />
    </>
  );
}
